import { render, staticRenderFns } from "./TabPurchaseInvoiceDetailLines.vue?vue&type=template&id=d8b4612e"
import script from "./TabPurchaseInvoiceDetailLines.vue?vue&type=script&setup=true&lang=js"
export * from "./TabPurchaseInvoiceDetailLines.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports